import React, {useEffect, useState} from "react";

import PeopleAltOutlined from "@mui/icons-material/PeopleAltOutlined";
import StyleIcon from "@mui/icons-material/Style";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import EditIcon from '@mui/icons-material/Edit';
import {useSelector} from "react-redux";
import {selectUserAccount, selectUserPictureUrl} from "../../../stores/account/account.selectors";
import "./MyAccountMenu.style.scss"
import useAppModalService from "../../../hooks/useAppModalService";
import ChangePicturePopUp from "../../PopUps/ChangePicturePopUp/ChangePicturePopUp";
import {FormattedMessage} from "react-intl";
import GlobalConst from "../../../constants/GlobalConst";

const MyAccountNav = Object.freeze({
    MY_PROFILE: 'myprofile',
    MY_PICKS: 'mypicks',
    WITHDRAW_FUNDS: 'withdrawfunds',
    TRANSACTION_HISTORY: 'transactionhistory',
})

const MyAccountMenu = ({handleNavigation, handleRedirectMyAccountClick, currentView, screenHeight}) => {
    const {openModal, closeModal, modalStack, stackSize} = useAppModalService();

    const iconStyle = {marginRight: "5px", fontSize: "1.3rem", position: "relative", top: "4px"}
    const userAccount = useSelector(selectUserAccount);
    const userPicUrl = useSelector((state) => selectUserPictureUrl(state, userAccount?.accountId));


    const handleOpenModal = async () => {
        try {
            const result = await openModal('exampleModal', 'info', {
                title: 'Example Modal',
                subtitle: 'This is an example modal',
                details: 'Some details about the modal',
                modalComponent: ChangePicturePopUp,
                onOk: () => console.log('OK clicked'),
                onCancel: () => console.log('Cancel clicked'),
                onClose: () => console.log('Close clicked'),
            });
        } catch (error) {
            console.error('Error opening modal:', error);
        }
    };

    return (
        <div className="MyAccountMenu" style={{minHeight: screenHeight}}>
            <div className="accountInfo">
                <div className="accountPicture" style={{backgroundImage: `url(${userPicUrl})`}}/>
                <div className="pseudonym gold-gradient-text">{userAccount?.pseudonym}</div>
                <div className="accountName">{userAccount?.fullName}</div>
                <div className="accountEditIcon" onClick={handleOpenModal}><EditIcon/></div>
            </div>
            <div className="accountNavigation">
                <div className={`${currentView === MyAccountNav.MY_PROFILE ? "selected gold-gradient-text" : ""}`}
                     onClick={() => handleNavigation(MyAccountNav.MY_PROFILE)}>
                    <FormattedMessage id="myAccountView.myAccountMenu.myProfile"/>
                </div>
                <div className={`${currentView === MyAccountNav.MY_PICKS ? "selected gold-gradient-text" : ""}`}
                     onClick={() => handleNavigation('mypicks/ongoing')}>
                    <FormattedMessage id="myAccountView.myAccountMenu.myPicks"/>
                </div>
                <div className={`${currentView === MyAccountNav.WITHDRAW_FUNDS ? "selected gold-gradient-text" : ""}`}
                     onClick={() => GlobalConst.FEATURES.ENABLE_LEGACY_PAGES ?
                         handleRedirectMyAccountClick('WithdrawFunds')
                         :
                         handleNavigation(MyAccountNav.WITHDRAW_FUNDS)}>
                    <FormattedMessage id="myAccountView.myAccountMenu.withdrawFunds"/>
                </div>
                <div className={`${currentView === MyAccountNav.TRANSACTION_HISTORY ? "selected gold-gradient-text" : ""}`}
                     onClick={() => handleNavigation(MyAccountNav.TRANSACTION_HISTORY)}>
                    <FormattedMessage id="myAccountView.myAccountMenu.transactionHistory"/>
                </div>
            </div>
        </div>
    );
}

export default MyAccountMenu;